import * as React from "react";
import { Price } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
const SubscriptionDailyIntervalPriceCaption = ({
  price,
  isCentAmount,
  priceInterval
}) => {
  const { getFormattedLabel, currency } = useIntl();
  return /* @__PURE__ */ React.createElement(Text, { component: "span", variant: "body" }, " (", /* @__PURE__ */ React.createElement(Price, { value: price, currency, centAmount: isCentAmount }), " / ", getFormattedLabel("common.frequency.perDays", { labelData: { days: priceInterval } }), ")");
};
export {
  SubscriptionDailyIntervalPriceCaption
};
//# sourceMappingURL=SubscriptionDailyIntervalPriceCaption.js.map
